import { render } from "./edu-coppa-dialog.vue?vue&type=template&id=b9139d10"
import script from "./edu-coppa-dialog.vue?vue&type=script&lang=js"
export * from "./edu-coppa-dialog.vue?vue&type=script&lang=js"

import "./edu-coppa-dialog.vue?vue&type=style&index=0&id=b9139d10&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__